'use client'

import { ChevronIcon, Link, useAuth, useConfig } from '@payloadcms/ui';
import { TextFieldClientProps } from 'payload';
import React from 'react';
import { options } from '../../options';

type UserWithRoles = {
  roles?: string[];
};

export const AfterNavLinks: React.FC<TextFieldClientProps> = (props) => {
  const { config } = useConfig();
  const { routes: { admin: adminRoute } } = config;
  const { user } = useAuth<UserWithRoles>();
  const userRoles = user?.roles || [];
  const isAdmin = userRoles.includes('admin');
  const canAccessLlm =
    isAdmin ||
    userRoles.includes(options.roles.LlmContributor) ||
    userRoles.includes(options.roles.LlmEditor);
  return (
    <>
      {isAdmin && (
        <div className="nav-group">
          <span className="nav__label">LLM TEST</span>
          <nav>
            <Link
              className="nav__link"
              href={`${adminRoute}/llm-test`}
            >
              <ChevronIcon />
              Llm Test
            </Link>
          </nav>
        </div>
      )}
      {(isAdmin || canAccessLlm) && (
        <div className="nav-group">
          <span className="nav__label">LLM LINKS</span>
          <nav>
            <Link
              className="nav__link"
              href={`${adminRoute}/llm-links`}
            >
              <ChevronIcon />
              Llm Links
            </Link>
          </nav>
        </div>
      )}
    </>
  );
};
